import * as React from 'react'
import { cn } from '@/lib/utils'

type Color = 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error'
type Variant = 'neutral' | 'soft'

type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: Variant
  color?: Color
}

const softColorMap: Record<Color, string> = {
  default: 'text-foreground/80 border-border/40 bg-foreground/5',
  primary: 'text-primary border-primary/30 bg-primary/10',
  secondary: 'text-secondary border-secondary/30 bg-secondary/10',
  info: 'text-sky-500 dark:text-sky-400 border-sky-500/30 dark:border-sky-400/30 bg-sky-500/10 dark:bg-sky-400/10',
  success: 'text-emerald-500 dark:text-emerald-400 border-emerald-500/30 dark:border-emerald-400/30 bg-emerald-500/10 dark:bg-emerald-400/10',
  warning: 'text-amber-500 dark:text-amber-400 border-amber-500/30 dark:border-amber-400/30 bg-amber-500/10 dark:bg-amber-400/10',
  error: 'text-red-500 dark:text-red-400 border-red-500/30 dark:border-red-400/30 bg-red-500/10 dark:bg-red-400/10',
}

export function Badge({ className, variant = 'neutral', color = 'default', ...props }: BadgeProps) {
  if (variant === 'soft') {
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-md px-2 py-0.5 text-xs',
          'border',
          softColorMap[color],
          className,
        )}
        {...props}
      />
    )
  }
  // neutral (backward-compatible)
  return (
    <span
      className={cn('inline-flex items-center rounded-md bg-muted px-2 py-0.5 text-xs text-foreground/80', className)}
      {...props}
    />
  )
}
